import React from 'react';

export default function Spinner() {
  return (
    <div
      data-test-id="image-loader__qr-code-spinner"
      className="spinner-border image-loader__qr-code-spinner"
      role="status"></div>
  );
}
